import { jsx as T } from "react/jsx-runtime";
import { useState as L, useRef as j, useEffect as h, useCallback as R } from "react";
import { withManagedProps as _ } from "@made-people/managed-props";
import { withZod as k } from "@made-people/react-prop-guard";
import { z as t } from "zod";
import { clsx as N } from "clsx";
const I = "https://cdn.jsdelivr.net/npm/hls.js@1.5.15/dist/hls.min.js", D = () => new Promise((e, n) => {
  if (typeof window > "u") {
    n(new Error("window is undefined"));
    return;
  }
  if (window.Hls) {
    e();
    return;
  }
  const l = document.querySelector(
    `script[src="${I}"]`
  );
  if (l) {
    l.addEventListener("load", () => e()), l.addEventListener(
      "error",
      () => n(new Error("Failed to load hls.js script"))
    );
    return;
  }
  const o = document.createElement("script");
  o.src = I, o.async = !0, o.onload = () => {
    window.Hls ? e() : n(new Error("hls.js loaded but window.Hls is undefined"));
  }, o.onerror = () => {
    n(new Error("Failed to load hls.js script"));
  }, document.body.appendChild(o);
}), M = ".m3u8", A = 1e8, P = ({
  hlsConfig: e,
  highestQuality: n,
  autoPlay: l,
  onReady: o
}) => {
  const [r, c] = L(!1), [b, H] = L(!1), p = j(null);
  h(() => () => {
    var i;
    (i = p.current) == null || i.destroy();
  }, []), h(() => {
    let i = !0;
    return D().then(() => {
      i && H(!0);
    }).catch((a) => {
      console.error("Error loading hls.js:", a);
    }), () => {
      i = !1;
    };
  }, []);
  const S = R(
    (i, a) => {
      var f;
      const d = () => {
        l && a.play().catch(() => {
          console.warn(
            "Unable to autoplay prior to user interaction with the DOM."
          );
        }), o == null || o();
      }, E = () => {
        var m;
        (m = p.current) == null || m.destroy(), c(!0);
        const s = {
          ...e,
          enableWorker: !1
        };
        n && (s.startLevel = 999, s.abrEwmaDefaultEstimate = A);
        const u = new window.Hls(s);
        p.current = u, u.loadSource(i), u.attachMedia(a), u.on(window.Hls.Events.MANIFEST_PARSED, () => {
          n && u.levels.length > 0 && (u.currentLevel = u.levels.length - 1), d();
        });
      }, y = () => {
        var s;
        (s = p.current) == null || s.destroy(), p.current = null, c(!1), a.src = i, d();
      }, v = i.includes(M), g = a.canPlayType("application/vnd.apple.mpegurl") === "probably";
      if (v && !g) {
        if (!b || !((f = window.Hls) != null && f.isSupported()))
          return;
        E();
      } else
        y();
    },
    [e, n, l, o, b]
  );
  return { isHls: r, initHls: S };
}, C = 1024, F = (e, n = C) => {
  const [l, o] = L(
    typeof e == "string" ? e : (e == null ? void 0 : e.desktop) || (e == null ? void 0 : e.mobile) || null
  ), r = R(() => {
    if (typeof e == "string")
      o(e);
    else {
      const c = window.innerWidth > n;
      o(
        c ? (e == null ? void 0 : e.desktop) || (e == null ? void 0 : e.mobile) : (e == null ? void 0 : e.mobile) || (e == null ? void 0 : e.desktop)
      );
    }
  }, [e, n]);
  return h(() => (r(), window.addEventListener("resize", r), () => window.removeEventListener("resize", r)), [r]), l;
}, V = t.object({
  /** Optional HLS configuration */
  hlsConfig: t.custom().optional(),
  /** Optional ref for the video player element */
  playerRef: t.custom().optional(),
  /** Optional forwarded ref */
  ref: t.custom().optional()
}), x = t.object({
  /** Optional breakpoint to switch between mobile and desktop sources */
  breakpointToSwitchSources: t.number().optional(),
  style: t.custom().optional(),
  /** Video source URL or object with default and desktop URLs */
  src: t.string().or(
    t.object({
      mobile: t.string().optional(),
      desktop: t.string().optional()
    }).optional()
  ),
  /** Optional poster image URL */
  poster: t.string().optional(),
  // Added poster prop
  /** Whether to use the highest quality available */
  highestQuality: t.boolean().optional(),
  /** Callback function when the video is ready */
  onReady: t.function().optional(),
  /** Whether the video should autoplay */
  autoPlay: t.boolean().optional(),
  /** Whether to show video controls */
  controls: t.boolean().optional(),
  /** Whether the video should loop */
  loop: t.boolean().optional(),
  /** Whether the video should play inline on mobile devices */
  playsInline: t.boolean().optional(),
  /** Whether the video should be muted */
  muted: t.boolean().optional(),
  /** CSS class name for the video element */
  className: t.string().optional()
}), O = V.merge(x), G = _(
  "ResponsiveVideo",
  k(
    O,
    ({
      hlsConfig: e,
      playerRef: n,
      autoPlay: l = !0,
      src: o,
      muted: r = !0,
      controls: c = !1,
      highestQuality: b = !1,
      playsInline: H = !0,
      breakpointToSwitchSources: p,
      style: S,
      onReady: i,
      poster: a,
      ref: d,
      className: E,
      loop: y = !0,
      ...v
    }) => {
      if (!o || typeof o == "object" && !(o != null && o.mobile) && !(o != null && o.desktop))
        return null;
      const g = j(null), w = n || g, f = F(o, p), { initHls: s } = P({
        hlsConfig: e,
        highestQuality: b,
        autoPlay: l,
        onReady: i
      });
      return h(() => {
        f && w.current && s(f, w.current);
      }, [f, s, w]), /* @__PURE__ */ T(
        "video",
        {
          autoPlay: l,
          "data-is-video": !0,
          muted: r,
          poster: a,
          loop: y,
          ref: (m) => {
            typeof d == "function" ? d(m) : d && (d.current = m), w.current = m;
          },
          controls: c,
          playsInline: H,
          style: S,
          ...v,
          className: N("object-cover w-full h-full", E)
        }
      );
    }
  )
);
export {
  G as ResponsiveVideo,
  O as fullSchema,
  V as hlsSchema,
  D as loadHlsScript,
  x as responsiveVideoSchema,
  P as useHls,
  F as useVideoSource
};
//# sourceMappingURL=index.es.js.map
